export const BILLING_REBRAND_INFO_FF = 'billing-rebrand-banner';
